export default __webpack_public_path__ + "static/media/postFour.04ebf15d.jpg";